import { Component, inject, OnInit } from '@angular/core';
import { NewsInterface, PersonInterface } from '@campus/dal';
import { Observable } from 'rxjs';

import { NewsModalViewModel } from './news-modal.viewmodel';

@Component({
  standalone: false,
  selector: 'campus-news-modal',
  templateUrl: './news-modal.component.html',
  styleUrl: './news-modal.component.scss',
})
export class NewsModalComponent implements OnInit {
  private viewModel = inject(NewsModalViewModel);
  public news$: Observable<{ user: PersonInterface; items: NewsInterface[] }>;

  ngOnInit(): void {
    this.news$ = this.viewModel.newsAnnouncementsForUser$;
  }

  onDialogConfirm(allNews: NewsInterface[]): void {
    this.viewModel.markNewsAsRead(allNews);
  }
}
